var u=function(r){return r.GROUP="group",r.ITEM="item",r.SUBGROUP="subgroup",r}({});export{u as NavigationType};